module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 8h-4V2c0-1.106-.894-2-2-2H8C6.894 0 6 .894 6 2v6H2c-1.106 0-2 .894-2 2v16c0 1.106.894 2 2 2h4v2c0 1.106.894 2 2 2h16c1.106 0 2-.894 2-2v-2h4c1.106 0 2-.894 2-2V10c0-1.106-.894-2-2-2zM10 4h12v4H10V4zm10 10v4h-4v-4h4zm2 14H10v-4h12v4zm4-10h-4v-4h4v4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/printer-1.js
// module id = 1358
// module chunks = 14